import { render, staticRenderFns } from "./summary-info.html?vue&type=template&id=a67e24b6&scoped=true&external"
import script from "./summary-info.js?vue&type=script&lang=js&external"
export * from "./summary-info.js?vue&type=script&lang=js&external"
import style0 from "./summary-info.scss?vue&type=style&index=0&id=a67e24b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67e24b6",
  null
  
)

export default component.exports